export const KeysTitles = {
    sizeOfUrbanArea: { title: "Size of Urban Area", description: "" },
    financialAccountsType: { 
        title: "Financial Accounts Type", 
        description: "Indicates the type of financial statements filed by the company.",
        valuesOptions: {
            F: "Full Accounts",
            M: "Micro Entity Accounts",
            S: "Small Company Accounts",
            A: "Abbreviated Accounts"
        }
    },
    officeType: { 
        title: "Office Type", 
        description: "Company office type information (Headoffice etc.).", 
        valuesOptions: {
            0: "Head Office",
            1: "Branch",
            "HeadOffice": "Head Office",
            "Branch": "Branch"
        } 
    },
    numberOfEmployeesAtAddress: { title: "Number of Employees at Address", description: "" },
    numberOfEmployeesAtCompany: { title: "Number of Employees at Company", description: "" },
    inseeCode: { title: "INSEE Code", description: "" },
    postalCode: { title: "Postal Code", description: "" },
    subRegion: { title: "Sub Region", description: "" },
    courtRegistryNumber: { title: "Court Registry Number", description: "" },
    registrationCourt: { title: "Registration Court", description: "" },
    numberOfDirectors: { title: "Number of Directors", description: "" },
    workforceAccount: { title: "Workforce Account", description: "" },
    summaryFormationDate: { title: "Summary Formation Date", description: "" },
    businessPagesFt: { title: "Business Pages FT", description: "" },
    preferentialRightsSummaryText: { title: "Preferential Rights Summary Text", description: "" },
    reasonForFormation: { title: "Reason for Formation", description: "" },
    statusCode: { 
        title: "Status Code", 
        description: "Indicates the company’s current legal status according to registry filings.",
        valuesOptions: {
            A: "Active",
            D: "Dissolved",
            I: "Inactive",
            S: "Suspended",
            R: "Registered"
        } 
    },
    numberOfBranches: { title: "Number of Branches", description: "" },
    previousSiret: { title: "Previous SIRET", description: "" },
    activityClassification: { title: "Activity Classification", description: "" },
    municipality: { title: "Municipality", description: "" },
    numberOfCompanies: { title: "Number of Companies", description: "" },
    courtRegistryNumberAdditional: { title: "Court Registry Number Additional", description: "" },
    preferentialStatus: { title: "Preferential Status", description: "" },
    postalAddress: { title: "Postal Address", description: "" },
    profitability: { 
        title: "Profitability", 
        description: "Indicates the direction of profitability compared to previous periods. ‘Increasing’ means profitability is improving.",
        valuesOptions: {
            Greater: "Increasing / Improving",
            Lower: "Decreasing / Declining",
            Stable: "Stable / No major change",
            Unknown: "Data not sufficient"
        }
    },
    liquidity: { 
        title: "Liquidity", 
        description: "Indicates the company’s ability to meet short-term financial obligations based on recent financial data.",
        valuesOptions: {
            Greater: "Increasing / Improving",
            Lower: "Decreasing / Declining",
            Stable: "Stable / No major change",
            Unknown: "Data not sufficient"
        }
    },
    dbt: { title: "DBT", description: "" },
    averageMonthlyBalance: { title: "Average Monthly Balance", description: "" },
    balanceP2: { title: "Balance P2", description: "" },
    balanceWithinTerms: { title: "Balance Within Terms", description: "" },
    totalTradeLinesOutstanding: { title: "Total Trade Lines Outstanding", description: "" },
    invoicesMoreThan30Days: { title: "Invoices More Than 30 Days", description: "" },
    totalInvoiceValue: { title: "Total Invoice Value", description: "" },
    highestInvoiceValueOutstanding: { title: "Highest Invoice Value Outstanding", description: "" },
    industryDbt: { title: "Industry DBT", description: "" },
    balance: { title: "Balance", description: "" },
    balanceP3: { title: "Balance P3", description: "" },
    recentHighBalance: { title: "Recent High Balance", description: "" },
    invoicesOutstanding: { title: "Invoices Outstanding", description: "" },
    averageInvoiceValue: { title: "Average Invoice Value", description: "" },
    totalBalanceStillOwingLate: { title: "Total Balance Still Owing Late", description: "" },
    paymentTrend: { title: "Payment Trend", description: "" },
    balanceP1: { title: "Balance P1", description: "" },
    balanceP4: { title: "Balance P4", description: "" },
    totalTradeLines: { title: "Total Trade Lines", description: "" },
    invoicesUpTo30Days: { title: "Invoices Up to 30 Days", description: "" },
    invoicesBeyond: { title: "Invoices Beyond", description: "" },
    totalBalanceStillOwing: { title: "Total Balance Still Owing", description: "" },
    highestInvoiceValueOutstandingLate: { title: "Highest Invoice Value Outstanding Late", description: "" },
    paidP1: { title: "Paid P1", description: "" },
    paidP2: { title: "Paid P2", description: "" },
    paidP3: { title: "Paid P3", description: "" },
    paidP4: { title: "Paid P4", description: "" },
    paidInTerms: { title: "Paid in Terms", description: "" },
    totalPaid: { title: "Total Paid", description: "" },
    paymentExpectationDays: { title: "Payment Expectation Days", description: "" },
    daySalesOutstanding: { title: "Day Sales Outstanding", description: "" },
    latestEnquiryDate: { title: "Latest Enquiry Date", description: "" },
    month1: { title: "Month 1", description: "" },
    month2: { title: "Month 2", description: "" },
    month3: { title: "Month 3", description: "" },
    month6: { title: "Month 6", description: "" },
    month7: { title: "Month 7", description: "" },
    month8: { title: "Month 8", description: "" },
    month9: { title: "Month 9", description: "" },
    month10: { title: "Month 10", description: "" },
    month11: { title: "Month 11", description: "" },
    month12: { title: "Month 12", description: "" },
    months1to3: { title: "Months 1 to 3", description: "" },
    months4to6: { title: "Months 4 to 6", description: "" },
    months7to9: { title: "Months 7 to 9", description: "" },
    months10to12: { title: "Months 10 to 12", description: "" },
    monthlyAverage: { title: "Monthly Average", description: "" },
    companyMonitoredSince: { title: "Company Monitored Since", description: "" },
    monitoredStoppedSince: { title: "Monitored Stopped Since", description: "" },
    statusOfMonitoring: { title: "Status of Monitoring", description: "" },
    currency: { title: "Currency", description: "" },
    numberOfActivePreferentialRights: { title: "Number of Active Preferential Rights", description: "" },
    numberOfPreferentialRights: { title: "Number of Preferential Rights", description: "" },
    typeOfEstablishmentDescription: { title: "Type of Establishment Description", description: "" },
    formationDate: { title: "Formation Date", description: "" },
    department: { title: "Department", description: "" },
    district: { title: "District", description: "" },
    area: { title: "Area", description: "" },
    city: { title: "City", description: "" },
    tradingAddress: { title: "Trading Address", description: "" },
    apeNafCode: { title: "APE/NAF Code", description: "" },
    regionality: { title: "Regionality", description: "" },
    monoActivityStatus: { title: "Mono Activity Status", description: "" },
    cash: { title: "Cash", description: "" },
    investments: { title: "Investments", description: "" },
    total_assets: { title: "Total Assets", description: "" },
    raw_materials: { title: "Raw Materials", description: "" },
    share_premium: { title: "Share Premium", description: "" },
    finished_goods: { title: "Finished Goods", description: "" },
    other_reserves: { title: "Other Reserves", description: "Other capital and reserves that form part of shareholders equity." },
    trade_payables: { title: "Trade Payables", description: "" },
    revenue_reserves: { title: "Revenue Reserves", description: "The accumulation of profits/losses from previous trading periods." },
    work_in_progress: { title: "Work in Progress", description: "" },
    other_inventories: { title: "Other Inventories", description: "" },
    total_inventories: { title: "Total Inventories", description: "" },
    total_liabilities: { title: "Total Liabilities", description: "" },
    total_receivables: { title: "Total Receivables", description: "" },
    trade_receivables: { title: "Trade Receivables", description: "" },
    land_and_buildings: { title: "Land and Buildings", description: "" },
    total_fixed_assets: { title: "Total Fixed Assets", description: "" },
    plant_and_machinery: { title: "Plant and Machinery", description: "" },
    other_current_assets: { title: "Other Current Assets", description: "" },
    total_current_assets: { title: "Total Current Assets", description: "" },
    other_tangible_assets: { title: "Other Tangible Assets", description: "" },
    total_tangible_assets: { title: "Total Tangible Assets", description: "" },
    other_loans_or_finance: { title: "Other Loans or Finance", description: "" },
    called_up_share_capital: { title: "Called Up Share Capital", description: "" },
    total_intangible_assets: { title: "Total Intangible Assets", description: "" },
    total_other_fixed_assets: { title: "Total Other Fixed Assets", description: "" },
    miscellaneous_liabilities: { title: "Miscellaneous Liabilities", description: "" },
    miscellaneous_receivables: { title: "Miscellaneous Receivables", description: "" },
    total_current_liabilities: { title: "Total Current Liabilities", description: "" },
    total_shareholders_equity: { title: "Total Shareholders' Equity", description: "" },
    miscellaneous_fixed_assets: { title: "Miscellaneous Fixed Assets", description: "" },
    total_long_term_liabilities: { title: "Total Long-Term Liabilities", description: "" },
    tax: { title: "Tax", description: "" },
    revenue: { title: "Revenue", description: "" },
    dividends: { title: "Dividends", description: "" },
    depreciation: { title: "Depreciation", description: "" },
    pension_costs: { title: "Pension Costs", description: "" },
    operating_costs: { title: "Operating Costs", description: "" },
    retained_profit: { title: "Retained Profit", description: "" },
    financial_income: { title: "Financial Income", description: "" },
    operating_profit: { title: "Operating Profit", description: "" },
    profit_after_tax: { title: "Profit After Tax", description: "" },
    profit_before_tax: { title: "Profit Before Tax", description: "" },
    financial_expenses: { title: "Financial Expenses", description: "" },
    wages_and_salaries: { title: "Wages and Salaries", description: "" },
    gearing: { title: "Gearing", description: "" },
    debtor_days: { title: "Debtor Days", description: "" },
    creditor_days: { title: "Creditor Days", description: "" },
    current_ratio: { title: "Current Ratio", description: "" },
    total_debt_ratio: { title: "Total Debt Ratio", description: "" },
    current_debt_ratio: { title: "Current Debt Ratio", description: "" },
    equity_in_percentage: { title: "Equity in Percentage", description: "" },
    stock_turnover_ratio: { title: "Stock Turnover Ratio", description: "" },
    pre_tax_profit_margin: { title: "Pre-Tax Profit Margin", description: "" },
    return_on_capital_employed: { title: "Return on Capital Employed", description: "" },
    liquidity_ratio_or_acid_test: { title: "Liquidity Ratio / Acid Test", description: "" },
    sales_or_net_working_capital: { title: "Sales / Net Working Capital", description: "" },
    return_on_net_assets_employed: { title: "Return on Net Assets Employed", description: "" },
    net_worth: { title: "Net Worth", description: "" },
    working_capital: { title: "Working Capital", description: "" },
    streetAddress: { title: "Street Address", description: "" },
    nationality: { title: "Nationality", description: "" },
    rcsRegistration: { title: "RCS Registration", description: "" },
    headQuarterSafeNumber: { title: "Headquarters Safe Number", description: "" },
    netWorth: { 
        title: "Net Worth", 
        description: "Represents the company’s total assets minus total liabilities, showing its overall financial strength.",
        valuesOptions: {
            Greater: "Increasing / Improving",
            Lower: "Decreasing / Declining",
            Stable: "Stable / No major change",
            Unknown: "Data not sufficient"
        }
    },
    invoicesTotal: { title: "Invoices Total", description: "" },
    other_intangible_assets: { title: "Other Intangible Assets", description: ""}
};

export const ActivityExposureOptions = {
    A: "Low",
    B: "Medium",
    C: "High",
    D: "Very High"
};

export const FinancialStatmentsTypes = {
    LocalFinancialsFullFlatCSFR: {
        title: "Full Accounts (France)",
        description: "Full official financial statements filed by the company, presented in a standardized flat format."
    },
    LocalFinancialsSynthesizedCSFR: {
        title: "Synthesized Financials (France)",
        description: "Financial data estimated by Creditsafe based on available information when full accounts are not provided."
    },
    LocalFinancialsSectorAveragesCSFR: {
        title: "Industry Averages (France)",
        description: "Average financial figures for companies within the same industry sector, used for benchmarking purposes."
    },
    LocalFinancialsSectorMediansCSFR: {
        title: "Industry Medians (France)",
        description: "Median financial values for companies within the same industry sector, providing a benchmark less affected by outliers."
    },
    GlobalFinancialsGGS: {
        title: "Global Financials",
        description: "Standardized financial data compiled at a global level, enabling cross-country comparison of company financials."
    }
};